import { csv } from "d3-fetch";
import dayjs from "dayjs";
import EVIC_DATA from "../data/eviction_filings__aug2020-feb2021.csv";

const loadData = () => {
  /* Fetch and parse files. */
  return Promise.all([csv(EVIC_DATA)]).then(([evicData]) => {
    const data = {};
    data.evicData = evicData.map((item) => {
      const { date, total } = item;
      const cleanDate = dayjs(date, "YYYY-MM-DD").unix();
      return {
        total: +total,
        date: cleanDate,
      };
    });
    return data;
  });
};

export default loadData;
